module.exports = __webpack_public_path__ + "img/767size.3c54234e.png";